import DataTable, { defaultThemes } from 'react-data-table-component';
import { IEsteira } from '../../interfaces/IRelatorioCliente';

function RelatoriosTabela({ colunas, itens, acaoTocarLinha }: { colunas: any, itens: IEsteira[], acaoTocarLinha?: (esteira: IEsteira) => void }) {
    const customStyles = {
        headCells: {
            style: {
                color: '#5E6397',
                fontFamily: 'Assistant',
                fontSize: '18px',
                paddingTop: '15px',
                paddingBottom: '15px',
                ':last-child': {
                    maxWidth: '100px',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default
                },
                ':first-child': {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default
                },
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default
            },
        },
        cells: {
            style: {
                color: '#A3A3A3',
                fontFamily: 'Merriweather Sans',
                fontSize: '16px',
                paddingTop: '15px',
                paddingBottom: '15px',
                cursor: 'pointer',
                ':last-child': {
                    maxWidth: '100px',
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
                ':first-child': {
                    borderLeftStyle: 'solid',
                    borderLeftWidth: '1px',
                    borderLeftColor: defaultThemes.default.divider.default,
                    color: '#525252',
                },
                borderBottomStyle: 'solid',
                borderBottomWidth: '1px',
                borderBottomColor: defaultThemes.default.divider.default,
            },
        }
    };

    return <>
        {
            itens.length > 0 ? <DataTable columns={colunas} data={itens} customStyles={customStyles} dense onRowClicked={acaoTocarLinha} /> : <h2 className="mt-5">Não existem clientes para serem exibidos</h2>
        }
    </>
}


export default RelatoriosTabela;